import React from 'react';
import { Typography } from '@mui/material';
import { QUESTION_HINT_EXAMPLES } from '../../constants';

import type { CampaignQuestion } from '../../types';

interface QuestionHintProps {
    question: CampaignQuestion;
}

/**
 * Hint under the question field.
 */
const QuestionHint: React.FC<QuestionHintProps> = ({ question }) => {
    if (question.text) return null;

    return (
        <Typography variant="caption" color="text.secondary">
            {QUESTION_HINT_EXAMPLES[question.type]}
        </Typography>
    );
};

export default QuestionHint;
